import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'
import { MemoryRouter } from 'react-router'

import { BankIntegrationContextProvider } from '@features/openBanking/contexts/bankIntegrationContext'
import { AccountsContextProvider } from '@modules-deprecated/app/accounts'
import {
  UserOrganizationContextProvider,
  UserOrganizationSettingsContextProvider,
} from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import InvoiceReconciliationModalWrapper from '@views/invoices/elements/InvoiceReconclliationModal/elements/InvoiceReconciliationModalWrapper'

import { queryClient } from '../../config/queryClient'
import { EmberCloseModalContextProvider, EmberModal } from '../../contexts/emberCloseModalContext'
import { ThemeProvider } from '../../contexts/themeProvider'

const MODULE_NAME = 'invoice-reconciliation-modal-module'

class InvoiceReconciliationModalWebComponent extends DOMModel {
  @byAttrVal invoiceId: string
  @byAttrVal organizationId: string
  @registerEvent('closeEmber') closeEmber: Function
}

interface InvoiceReconciliationModalProps {
  invoiceId: string
  organizationId: string
  onCloseEmber: EmberModal
}

/* Only used in old invoice ember view */
/* Safe to remove when all invoice views are migrated to new Invoice editor */
function InvoiceReconciliationModalModule({
  organizationId,
  invoiceId,
  onCloseEmber,
}: InvoiceReconciliationModalProps): ReactElement {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <EmberCloseModalContextProvider onCloseModal={onCloseEmber}>
          <ModalContextProvider>
            <CurrentUserContextProvider>
              <UserOrganizationContextProvider organizationId={organizationId}>
                <UserOrganizationSettingsContextProvider organizationId={organizationId}>
                  <MemoryRouter>
                    <BankIntegrationContextProvider organizationId={organizationId}>
                      <AccountsContextProvider organizationId={organizationId}>
                        <InvoiceReconciliationModalWrapper invoiceId={invoiceId} />
                      </AccountsContextProvider>
                    </BankIntegrationContextProvider>
                  </MemoryRouter>
                </UserOrganizationSettingsContextProvider>
              </UserOrganizationContextProvider>
            </CurrentUserContextProvider>
          </ModalContextProvider>
        </EmberCloseModalContextProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

const InvoiceReconciliationModalCustomElement = createCustomElement(
  InvoiceReconciliationModalModule,
  InvoiceReconciliationModalWebComponent,
  'element',
)

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, InvoiceReconciliationModalCustomElement)

export default InvoiceReconciliationModalCustomElement
